import axios from 'axios'

export const companiesGmbCategories = {
  namespaced: true,
  state: {
    data: [],
    loading: false,
  },
  mutations: {
    clearGmbCategories(state) {
      state.data = []
    },
    readGmbCategories(state) {
      state.loading = true
    },
    readGmbCategoriesSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    readGmbCategoriesFailure(state) {
      state.loading = false
    },
  },
  actions: {
    clearGmbCategories({ commit }) {
      commit('clearGmbCategories')
    },
    readGmbCategories({ commit }, { companyUuid, query }) {
      commit('readGmbCategories')
      let url = `/api/companies/${ companyUuid }/gmb/categories.json`
      if (query) url += `?query=${ query }`
      return axios
        .get(url)
        .then(res => {
          commit('readGmbCategoriesSuccess', res.data.data)
        })
        .catch(err => {
          commit('readGmbCategoriesFailure', err)
          console.error(err)
        })
    },
  }
}
